/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListWorkloadPlatformsSecurityOption1 = {
  sessionHeaderGramSession: string;
};

export type ListWorkloadPlatformsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListWorkloadPlatformsSecurity = {
  option1?: ListWorkloadPlatformsSecurityOption1 | undefined;
  option2?: ListWorkloadPlatformsSecurityOption2 | undefined;
};

export type ListWorkloadPlatformsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListWorkloadPlatformsSecurityOption1$Outbound = {
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListWorkloadPlatformsSecurityOption1$outboundSchema: z.ZodMiniType<
  ListWorkloadPlatformsSecurityOption1$Outbound,
  ListWorkloadPlatformsSecurityOption1
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listWorkloadPlatformsSecurityOption1ToJSON(
  listWorkloadPlatformsSecurityOption1: ListWorkloadPlatformsSecurityOption1,
): string {
  return JSON.stringify(
    ListWorkloadPlatformsSecurityOption1$outboundSchema.parse(
      listWorkloadPlatformsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListWorkloadPlatformsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListWorkloadPlatformsSecurityOption2$outboundSchema: z.ZodMiniType<
  ListWorkloadPlatformsSecurityOption2$Outbound,
  ListWorkloadPlatformsSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listWorkloadPlatformsSecurityOption2ToJSON(
  listWorkloadPlatformsSecurityOption2: ListWorkloadPlatformsSecurityOption2,
): string {
  return JSON.stringify(
    ListWorkloadPlatformsSecurityOption2$outboundSchema.parse(
      listWorkloadPlatformsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListWorkloadPlatformsSecurity$Outbound = {
  Option1?: ListWorkloadPlatformsSecurityOption1$Outbound | undefined;
  Option2?: ListWorkloadPlatformsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListWorkloadPlatformsSecurity$outboundSchema: z.ZodMiniType<
  ListWorkloadPlatformsSecurity$Outbound,
  ListWorkloadPlatformsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListWorkloadPlatformsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListWorkloadPlatformsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listWorkloadPlatformsSecurityToJSON(
  listWorkloadPlatformsSecurity: ListWorkloadPlatformsSecurity,
): string {
  return JSON.stringify(
    ListWorkloadPlatformsSecurity$outboundSchema.parse(
      listWorkloadPlatformsSecurity,
    ),
  );
}

/** @internal */
export type ListWorkloadPlatformsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListWorkloadPlatformsRequest$outboundSchema: z.ZodMiniType<
  ListWorkloadPlatformsRequest$Outbound,
  ListWorkloadPlatformsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listWorkloadPlatformsRequestToJSON(
  listWorkloadPlatformsRequest: ListWorkloadPlatformsRequest,
): string {
  return JSON.stringify(
    ListWorkloadPlatformsRequest$outboundSchema.parse(
      listWorkloadPlatformsRequest,
    ),
  );
}
